import { Component, HostBinding, inject, Input } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { navyBlue } from '@twaice-fe/frontend/shared/utilities';
import { IconSource } from '../../svg-icon/svg-icon.types';

@Component({
  selector: 'twaice-fe-side-nav-item',
  templateUrl: './side-nav-item.component.html',
  styleUrls: ['./side-nav-item.component.scss'],
  // this linting rule doesn't account for Angular 15 hostDirectives yet --> false positive
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  hostDirectives: [{ directive: RouterLinkActive, inputs: ['routerLinkActive', 'routerLinkActiveOptions'] }],
  standalone: false,
})
export class SideNavItemComponent {
  @Input() title: string;
  @Input() icon: string;
  @Input() iconSource: IconSource = 'custom';
  @Input() size = '16px';
  @Input() color = navyBlue;
  @HostBinding('class.side-nav-item__expanded') applyExpandedClass = false;

  // to be set by side-nav component
  get expanded(): boolean {
    return this._expanded;
  }

  set expanded(value: boolean) {
    this._expanded = value;
    this.applyExpandedClass = value;
  }

  private _expanded = false;

  private activeDirectory: RouterLinkActive = inject(RouterLinkActive, { self: true });

  constructor() {
    // attach active class & settings to RotuerLinkActive directory
    this.activeDirectory.routerLinkActive = 'side-nav-item__active';
  }
}
